export default __webpack_public_path__ + "images/0xc3c7d422809852031b44ab29eec9f1eff2a58756.png";